import store from 'store'

const el = '[data-content=SourceOverlay]'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((SourceOverlayDOM)=>{
            const data = {
                labels: JSON.parse(SourceOverlayDOM.dataset.labels),
            }
            store.commit('main/set_page_overlay_content_data', data)
        })
    }
}
